export default function auth({ next, store }) {
  if (!store.getters["auth/loggedIn"] && !localStorage.getItem("auth_token")) {
    return next({
      name: "Login",
    });
  }
  next();
}